/** Edit mode is a director/admin tool. Viewers and signed-out sessions never see it. */

export function canUseEditMode(user, scope = "full") {
  if (!user || scope === "reset_only") return false;
  return user.role === "director" || user.role === "admin";
}
